import React from 'react';
import PropTypes from 'prop-types';

import { TabComponents } from '@ohif/ui';

import { AiResultSetting } from './AIResultSetting.js';
import { AiResultFilterSetting } from './AIResultFilterSetting.js';

import './UserPreferences.styl';

const tabs = [
  {
    name: '显示结果设置',
    Component: AiResultSetting,
    customProps: {},
  },
  {
    name: '过滤条件设置',
    Component: AiResultFilterSetting,
    customProps: {},
  },
];

function AiPreferences({ hide }) {
  const customProps = {
    onClose: hide,
  };
  return <TabComponents tabs={tabs} customProps={customProps} />;
}

AiPreferences.propTypes = {
  hide: PropTypes.func,
};

export { AiPreferences };
